import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { EcitationSearchService } from 'src/services/ecitation-search.service';
import { AlertService } from '../alert-notify/alert-notify.service';
import { Subscription } from 'rxjs';
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { AuthService } from 'src/services/auth.service';

@Component({
    selector: 'app-ecitation-error-doc-search',
    templateUrl: './ecitation-error-doc-search.component.html',
    styleUrls: ['./ecitation-error-doc-search.component.css'],
    standalone: false
})
export class EcitationErrorDocSearchComponent implements OnInit, OnDestroy {

  showReportResults: boolean = false;
  errorDocSearchForm: any = FormGroup;
  outPut: any = [];
  selectedItems: any = [];
  alert: any;
  labelMap: { [Key: string]: string } = {
    citationNumber: 'Citation number',
    errorType: 'Error Type',
    createDateStart: 'Created Start Date',
    createDateEnd: 'Created End Date',
  }
  sortName= 'citationNumber';
  sortDir='desc';
  userTypeView:any;
  private subscription = new Subscription();

  constructor(private ecitationSearchService: EcitationSearchService,
     private _formBuilder: FormBuilder, public alertService: AlertService,
     private ecitationUserService:EcitationUserService,
     public authType:AuthService) {

      this.subscription.add(this.ecitationUserService.reloadComponent1$.subscribe(() => {
        this.showReportResults = false;
        this.currentPage = 1;
      }))
  }
  ngOnInit() {
    this.errorDocSearchForm = this.builform();
    this.userTypeView = this.authType.getUserType();
    this.authType.menuType = sessionStorage.getItem('menuType');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  builform() {
    return this._formBuilder.group({
      citationNumber: [''],
      errorType: [['ALL']],
      createDateStart: [''],
      createDateEnd: [''],

    })
  }
  resetForm() {
    this.errorDocSearchForm.reset(this.builform().value)
  }
  pageSize: number = 25;
  currentPage: number = 1;

  getItems() {
    return  this.outPut.content;
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.searchErrorDoc(this.sortName,this.sortDir);
  }

  getTotalPages(): number {
    return (this.outPut.totalPages); 
  }

  getVisiblePages(): number[] {
    const totalVisiblePages = 10;
    const visiblePages: number[] = [];
    const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages / 2));
    const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i)
    }
    return visiblePages
  }
  onSort(event: any, name: any, isSortable: boolean) {
    if (isSortable) {
      let target = event.currentTarget,

        spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i') : event.target,
        classList = spanEle.classList;
      let sortDir = 1;
      if (classList.contains('fa-sort') || classList.contains('fa-sort-up')) {
        classList.remove('fa-sort')
        classList.remove('fa-sort-up')
        classList.add('fa-sort-down')
        sortDir = -1
      } else {
        classList.add('fa-sort-up')
        classList.remove('fa-sort-down')

      }
      this.sortBy(name, sortDir)
    }
  }

  sortBy(name: string, order: number) {
    var orderVal = order ==1?'asc':'desc';
    this.sortName = name;
    this.sortDir= orderVal;
    this.searchErrorDoc(name,orderVal)
  }

  searchErrorDoc(name = 'citationNumber', dec = 'desc') {
  if (this.errorDocSearchForm.valid) {
    const params = this.errorDocSearchForm.value;

    params.page = this.currentPage - 1;
    params.size = this.pageSize;

    // Only primary sort, backend guarantees citationErrorId fallback
    params.sort = `${name},${dec}`;

    const postParam = this.generateParams(params);
    const postP = postParam ? `?${postParam}` : '';

    console.log('Final postP:', postP);

    this.ecitationSearchService.getErrorDocResults(postP).subscribe((res) => {
      this.outPut = res;
      this.outPut.content.forEach((element: any, i: any) => {
        element.id = `errordoc-${this.currentPage}-${i}`;
        element.checked = false;
      });
      this.showReportResults = true;
    });
  } else {
    alert('Please fill all required fields.');
  }
}

  generateParams(params: any) {
    const queryParams = [];
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        if (params[key] !== '' || params[key] !== null || params[key] !== undefined) {
          if (Array.isArray(params[key])) {
            params[key].forEach((value: string | number | boolean) => {
              let encodeKey = encodeURIComponent(key);
              let encodedvalue = encodeURIComponent(value);
              queryParams.push(encodeKey + '=' + encodedvalue)

            });
          } else {
            let encodeKey = encodeURIComponent(key);
            let encodedvalue = encodeURIComponent(params[key]);
            queryParams.push(encodeKey + '=' + encodedvalue)

          }
        }
      }

    }
    return queryParams.join('&');
  }

  toggleSelection(item:any){
    const index = this.selectedItems.findIndex((selectedRow: any)=> selectedRow.id === item.id);
    if(index > -1){
      this.selectedItems.splice(index,1);
    }else{
      this.selectedItems.push(item)
    }
  }

  isSelected(item:any){
    console.log(item,this.selectedItems)
    return this.selectedItems.some((r:any) => r.id === item.id)
  }

  deleteSelected() {
    var filteredResults = this.selectedItems.filter((x: any) => { return x.citationErrorId })
    if (filteredResults.length > 0) {
      const newFilter = filteredResults.map(({ citationErrorId }: any) => (citationErrorId))
      var q = this.generateParams({ citationErrorIds: newFilter })
      let f2 = filteredResults.map((x: any) => { return x.citationNumber })
      this.ecitationSearchService.deleteErrorDoc(q).subscribe((data) => {
        this.alertService.success(`Error Doc Deleted Sucessfully ${f2.join(', ')} `)
        this.searchErrorDoc();
        this.selectedItems = []
      })
    } else {
      this.alertService.error('Please select at least one citation to perform this action')
    }
  }

  searchQuery() {
    return `You searched for: ${this.constructSearchString(this.errorDocSearchForm)} `
  }

  constructSearchString(formGroup: FormGroup): string {
    let searchParts: any = [];
    Object.keys(formGroup.controls).forEach(key => {
      const control: AbstractControl = formGroup.controls[key];
      const label = this.labelMap[key] || key;
      if (control.value !== null && control.value !== '') {
        searchParts.push(`${label}: ${control.value}`);
      }
    });
    return searchParts.join(', ');
  }

  getCurrentPageTotal() {
    if (this.currentPage * this.pageSize > this.outPut.totalElements) {
      return this.outPut.totalElements
    } else {
      return this.currentPage * this.pageSize
    }
  }

}
